// quizQuestions.js
const quizQuestions = [
  {
    // Easy – Logical Reasoning
    difficulty: "Easy",
    question: "If all roses are flowers and some flowers fade quickly, which statement is true?",
    options: [
      "All roses fade quickly.",
      "Some roses fade quickly.",
      "No roses fade quickly.",
      "Some flowers are roses."
    ],
    answer: "Some flowers are roses.",
    explanation: "The statement 'all roses are flowers' means that roses are a subset of flowers, which means some flowers are roses. We can't conclude anything about which roses fade quickly from the given information."
  },
  {
    // Easy – Logical Reasoning
    difficulty: "Easy",
    question: "If John is taller than Mary and Mary is taller than Sam, who is the shortest?",
    options: ["John", "Mary", "Sam", "Cannot determine"],
    answer: "Sam",
    explanation: "If John > Mary and Mary > Sam (where > means 'taller than'), then John > Mary > Sam, making Sam the shortest person among the three."
  },
  {
    // Easy – Logical Reasoning
    difficulty: "Easy",
    question: "A train leaves Station A at 3 PM and arrives at Station B at 5 PM. How long is the trip?",
    options: ["1 hour", "2 hours", "3 hours", "4 hours"],
    answer: "2 hours",
    explanation: "From 3 PM to 5 PM is a duration of 2 hours (5 - 3 = 2)."
  },
  {
    // Easy – Pattern Recognition
    difficulty: "Easy",
    question: "What comes next in the sequence: 2, 4, 6, 8, ___?",
    options: ["9", "10", "12", "14"],
    answer: "10",
    explanation: "This is a sequence of even numbers, increasing by 2 each time: 2, 4, 6, 8, 10, ..."
  },
  {
    // Easy – Deductive Reasoning
    difficulty: "Easy",
    question: "All cats are mammals. All mammals have lungs. Therefore, all cats have ____.",
    options: ["Tails", "Lungs", "Whiskers", "Claws"],
    answer: "Lungs",
    explanation: "If all cats are mammals and all mammals have lungs, then it follows logically that all cats have lungs."
  },
  {
    // Easy – Hypothesis Testing
    difficulty: "Easy",
    question: "A chef notices that adding salt makes food taste better. What is the hypothesis?",
    options: ["Salt enhances flavor.", "Salt is unhealthy.", "Food tastes worse with salt.", "Salt has no effect on taste."],
    answer: "Salt enhances flavor.",
    explanation: "A hypothesis is a proposed explanation for an observation. Since the chef observed that adding salt makes food taste better, the hypothesis would be that salt enhances flavor."
  },
  {
    // Easy – Problem-Solving
    difficulty: "Easy",
    question: "A farmer has 17 sheep, and all but 9 die. How many sheep are left?",
    options: ["8", "9", "17", "0"],
    answer: "9",
    explanation: "The statement 'all but 9 die' means that 9 sheep did not die. So there are 9 sheep left."
  },
  {
    // Easy – Problem-Solving
    difficulty: "Easy",
    question: "If you have 3 apples and you take away 2, how many do you have?",
    options: ["1", "2", "3", "0"],
    answer: "2",
    explanation: "If you take away 2 apples, you have the 2 apples that you took. The question asks how many you have, not how many are left."
  },
  {
    // Easy – Abstract Reasoning
    difficulty: "Easy",
    question: "Which shape does not belong: Circle, Square, Triangle, Rectangle?",
    options: ["Circle", "Square", "Triangle", "Rectangle"],
    answer: "Circle",
    explanation: "A circle is the only shape without straight lines or angles. Squares, triangles, and rectangles all have straight lines and angles."
  },
  {
    // Medium – Pattern Recognition
    difficulty: "Medium",
    question: "What comes next in the sequence: O, T, T, F, F, S, S, ___?",
    options: ["E", "T", "N", "S"],
    answer: "E",
    explanation: "This sequence represents the first letters of the numbers: One, Two, Three, Four, Five, Six, Seven, Eight. So 'E' for Eight comes next."
  },
  {
    // Medium – Deductive Reasoning
    difficulty: "Medium",
    question: "If it rains, the ground gets wet. The ground is wet. What can you conclude?",
    options: ["It rained.", "It did not rain.", "The ground is always wet.", "Cannot determine"],
    answer: "Cannot determine",
    explanation: "This is a logical fallacy called 'affirming the consequent'. Just because the ground is wet doesn't mean it rained. The ground could be wet for other reasons (sprinklers, spilled water, etc.)."
  },
  {
    // Medium – Deductive Reasoning
    difficulty: "Medium",
    question: "All birds have feathers. A penguin is a bird. What can you conclude?",
    options: ["Penguins can fly.", "Penguins have feathers.", "Penguins are mammals.", "Penguins live in the Arctic."],
    answer: "Penguins have feathers.",
    explanation: "If all birds have feathers and a penguin is a bird, then a penguin must have feathers. This is valid deductive reasoning."
  },
  {
    // Medium – Hypothesis Testing
    difficulty: "Medium",
    question: "A scientist observes that plants grow taller with more sunlight. What is the hypothesis?",
    options: ["Sunlight causes plants to grow taller.", "Plants need water to grow.", "Tall plants need less sunlight.", "Sunlight has no effect on plants."],
    answer: "Sunlight causes plants to grow taller.",
    explanation: "A hypothesis is a proposed explanation for an observation. The scientist observed a correlation between sunlight and plant height, so the hypothesis would be that sunlight causes plants to grow taller."
  },
  {
    // Medium – Hypothesis Testing
    difficulty: "Medium",
    question: "A student notices that studying with music improves their grades. What is the hypothesis?",
    options: ["Music helps concentration.", "Music distracts from studying.", "Grades are unrelated to music.", "Studying without music is better."],
    answer: "Music helps concentration.",
    explanation: "The student observed that music correlates with better grades. A reasonable hypothesis would be that music helps with concentration, which leads to better grades."
  },
  {
    // Medium – Decision-Making
    difficulty: "Medium",
    question: "You have 10 and want to buy a snack. A candy bar costs 2, and a sandwich costs $5. What is the best decision?",
    options: [
      "Buy 5 candy bars.",
      "Buy 1 sandwich and 2 candy bars.",
      "Buy 2 sandwiches.",
      "Save the money."
    ],
    answer: "Buy 1 sandwich and 2 candy bars.",
    explanation: "With $10, buying 1 sandwich ($5) and 2 candy bars ($4) gives you the most value for $9, with $1 left over. 5 candy bars would cost $10 but might not be as satisfying. 2 sandwiches would cost the full $10 but might be too much food."
  },
  {
    // Medium – Decision-Making
    difficulty: "Medium",
    question: "You have 1 hour to complete a task. It usually takes 30 minutes, but today you feel tired. What should you do?",
    options: [
      "Start immediately.",
      "Take a 30-minute nap first.",
      "Skip the task.",
      "Ask for help."
    ],
    answer: "Start immediately.",
    explanation: "Starting immediately is the safest option. Even if you're tired and work slower, you still have twice the usual time to complete the task. Taking a 30-minute nap would leave you with only 30 minutes, which is risky."
  },
  {
    // Medium – Logical Reasoning
    difficulty: "Medium",
    question: "A man is looking at a portrait of someone. His friend asks, \"Who is it you are looking at?\" The man replies, \"Brothers and sisters, I have none. But that man's father is my father's son.\" Who is in the portrait?",
    options: ["His son", "His father", "Himself", "His uncle"],
    answer: "His son",
    explanation: "The man has no brothers or sisters, so 'my father's son' refers to himself. Therefore, 'that man's father is my father's son' means 'that man's father is me.' So the man in the portrait is his son."
  },
  {
    // Medium – Logical Reasoning
    difficulty: "Medium",
    question: "A woman has 7 children. Half of them are boys. How is this possible?",
    options: ["All the children are boys.", "She has twins.", "The other half are also boys.", "She has 3 boys and 4 girls."],
    answer: "She has 3 boys and 4 girls.",
    explanation: "The key insight is that half of 7 is 3.5, which is not a whole number. So 'half' here means 3/7. The woman has 3 boys and 4 girls, with 3 being approximately half of 7."
  },
  {
    // Medium – Logical Reasoning
    difficulty: "Medium",
    question: "A man pushes his car to a hotel and tells the owner he is bankrupt. What is happening?",
    options: ["He lost a bet.", "He is playing Monopoly.", "He is in a dream.", "He is a taxi driver."],
    answer: "He is playing Monopoly.",
    explanation: "This is a riddle about the board game Monopoly. In Monopoly, players move car tokens around the board, can land on hotel properties, and can go bankrupt."
  },
  {
    // Hard – Logical Reasoning
    difficulty: "Hard",
    question: "You are a prisoner in a room with 2 doors and 2 guards. One door leads to freedom, and the other leads to execution. One guard always tells the truth, and the other always lies. You can ask one guard one question to find the door to freedom. What do you ask?",
    options: [
      "Which door leads to freedom?",
      "If I asked the other guard which door leads to freedom, what would they say?",
      "Are you the truth-teller?",
      "What is your favorite color?"
    ],
    answer: "If I asked the other guard which door leads to freedom, what would they say?",
    explanation: "If you ask the truth-teller, he will correctly tell you what the liar would say, which would be the wrong door. If you ask the liar, he will lie about what the truth-teller would say, also indicating the wrong door. Either way, you get the wrong door, so you should choose the opposite door of what either guard tells you."
  },
  {
    // Hard – Logical Reasoning
    difficulty: "Hard",
    question: "You are in a room with three light switches. One controls a light in the next room, and the other two do nothing. You can flip the switches as much as you want, but you can only enter the next room once. How do you determine which switch controls the light?",
    options: [
      "Flip the first switch, wait 5 minutes, then flip it off and check the light.",
      "Flip all switches at once and check the light.",
      "Flip the first switch and leave it on, then check the light.",
      "Flip the second switch, wait 5 minutes, then flip it off and check the light."
    ],
    answer: "Flip the first switch, wait 5 minutes, then flip it off and check the light.",
    explanation: "Turn the first switch on for 5 minutes, then turn it off. Turn the second switch on and leave it on. Leave the third switch off. When you enter the room: if the light is on, it's controlled by the second switch. If the light is off but warm, it's controlled by the first switch. If the light is off and cool, it's controlled by the third switch."
  },
  {
    // Hard – Logical Reasoning
    difficulty: "Hard",
    question: "You have two ropes that each take exactly 1 hour to burn, but they burn at inconsistent rates. How can you measure exactly 45 minutes using the ropes?",
    options: [
      "Light both ends of the first rope and one end of the second rope.",
      "Light one end of the first rope and both ends of the second rope.",
      "Light both ends of both ropes.",
      "Light one end of each rope and wait for them to burn completely."
    ],
    answer: "Light both ends of the first rope and one end of the second rope.",
    explanation: "Light both ends of the first rope and one end of the second rope. The first rope will burn in 30 minutes (half the time) when lit from both ends. When the first rope is completely burned, light the other end of the second rope. The second rope will have been burning from one end for 30 minutes, and when you light the other end, it will burn for 15 more minutes. Total time: 30 + 15 = 45 minutes."
  },
  {
    // Hard – Logical Reasoning
    difficulty: "Hard",
    question: "You are in a room with no windows or doors. The only items are a mirror and a table. How do you escape?",
    options: [
      "Look in the mirror to see what you saw. Use the saw to cut the table in half.",
      "Use the mirror to signal for help.",
      "Break the mirror and use the shards to dig a hole.",
      "There is no way to escape."
    ],
    answer: "Look in the mirror to see what you saw. Use the saw to cut the table in half.",
    explanation: "This is a wordplay riddle. When you look in the mirror, you 'see what you saw' (a saw). Then you 'use the saw to cut the table in half'. When you have two halves, you put them together to make a 'hole' (whole), and you escape through the hole."
  },
  {
    // Hard – Logical Reasoning
    difficulty: "Hard",
    question: "You are in a room with three jars: one contains only apples, one contains only oranges, and one contains a mix of both. The jars are mislabeled. How can you correctly label the jars by picking only one fruit?",
    options: [
      "Pick a fruit from the jar labeled 'Mixed.'",
      "Pick a fruit from the jar labeled 'Apples.'",
      "Pick a fruit from the jar labeled 'Oranges.'",
      "Shake the jars and listen for the sound."
    ],
    answer: "Pick a fruit from the jar labeled 'Mixed.'",
    explanation: "Since all jars are mislabeled, the jar labeled 'Mixed' must contain either only apples or only oranges. If you pick a fruit from this jar, you'll know what's in it. If it's an apple, the jar contains only apples. Then the jar labeled 'Oranges' must contain the mix (since it can't contain oranges), and the jar labeled 'Apples' must contain only oranges."
  },
  {
    // Hard – Logical Reasoning
    difficulty: "Hard",
    question: "A man is found dead in a field with a backpack on. There are no footprints leading to or from the body. How did he die?",
    options: [
      "He was struck by lightning.",
      "He fell from an airplane.",
      "He was attacked by a wild animal.",
      "He died of natural causes."
    ],
    answer: "He fell from an airplane.",
    explanation: "Since there are no footprints leading to or from the body, the man must have arrived from above. The backpack suggests he was parachuting, but his parachute failed, causing him to fall to his death from an airplane."
  },
  {
    // Hard – Logical Reasoning
    difficulty: "Hard",
    question: "You have a 5-gallon jug and a 3-gallon jug. How can you measure exactly 4 gallons of water?",
    options: [
      "Fill the 5-gallon jug, pour it into the 3-gallon jug, and repeat.",
      "Fill the 3-gallon jug, pour it into the 5-gallon jug, and repeat.",
      "Fill both jugs and pour them into a larger container.",
      "Use a measuring cup to measure 4 gallons."
    ],
    answer: "Fill the 5-gallon jug, pour it into the 3-gallon jug, and repeat.",
    explanation: "1) Fill the 5-gallon jug completely (5 gallons). 2) Pour from the 5-gallon jug into the 3-gallon jug until it's full (5-3 = 2 gallons remain in the 5-gallon jug). 3) Empty the 3-gallon jug. 4) Pour the 2 gallons from the 5-gallon jug into the 3-gallon jug. 5) Fill the 5-gallon jug again. 6) Pour from the 5-gallon jug into the 3-gallon jug until it's full (it can only take 1 more gallon since it already has 2 gallons). 7) The 5-gallon jug now has exactly 4 gallons."
  }
];

export default quizQuestions;
